import { UserProfile } from "../../../model/User/UserProfile";
import { map, Observable } from "rxjs";
import { apiService } from "../../ApiService";

export const deleteFamilyProfile = (
  profile: UserProfile | string,
): Observable<UserProfile> => {
  return apiService
    .deleteApi<{ profile: UserProfile }>({
      path: `v1/family/profiles/${typeof profile === "string" ? profile : profile.id}`,
      requiresAuthPolicy: "user",
    })
    .pipe(map(({ profile }) => profile));
};
